import React from 'react';
import { useDesign } from '../contexts/DesignContext';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const TermsOfService = () => {
  const { designConfig } = useDesign();
  const siteName = designConfig.site_name || 'Viverra';
  const contactEmail = designConfig.contact_email || '[TODO: add support email in Admin Settings]';

  return (
    <StaticPageLayout title="Terms of Service" draftNotice>
      <p>
        These Terms of Service govern your use of {siteName} and any purchases you make with us. By using our
        site, you agree to these terms.
      </p>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Company</h2>
        <p>[TODO: add registered business/legal entity name and, if applicable, GSTIN/CIN].</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Products &amp; Pricing</h2>
        <p>
          Product images are for illustration and may vary slightly from the actual item. Prices and
          availability are subject to change without notice.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Orders &amp; Payment</h2>
        <p>
          Orders are confirmed once payment is successfully processed through our payment gateway partners.
          We reserve the right to cancel an order in cases such as pricing errors or stock unavailability.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Shipping &amp; Returns</h2>
        <p>
          See our Shipping Info and Returns pages for delivery estimates and our return process.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Intellectual Property</h2>
        <p>
          All content on this site, including images, text, and logos, belongs to {siteName} or its licensors
          and may not be used without permission.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Limitation of Liability</h2>
        <p>
          {siteName} is not liable for indirect or incidental damages arising from the use of this site or its
          products, to the extent permitted by law.
        </p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Governing Law</h2>
        <p>[TODO: confirm governing law/jurisdiction, e.g. courts of a specific city in India].</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Contact</h2>
        <p>Questions about these terms can be sent to {contactEmail}.</p>
      </div>

      <p className="text-sm text-gray-500">Last updated: [TODO: add date].</p>
    </StaticPageLayout>
  );
};

export default TermsOfService;
